import React from "react"
import { DataTable } from "home/components/data_table"

export default class BnccStudentPerformanceTablePresentation extends React.PureComponent {
  render () {
    return (
      <DataTable
        tableData={this.props.tableData}
        resource={this.props.resource}
        hasFilters={this.props.hasFilters}
        tableSize="big"
      />
    )
  }
}
